import objectPrefix from '../../lib/objectPrefix';

const prefix = objectPrefix();

module.exports = {

    puppetsMasterBg: {
        texture: '/img/partials/puppets-master/puppets-master-bg.jpg',
        scale: {
            x: '100%',
        },
        // position: {
        //     x: '0%',
        //     y: '-20%',
        // },
    },

    puppetsMaster1: {
        type: 'movieclip',
        scale: {
            x: '100%',
        },
        position: {
            x: '0%',
            y: '-0.5%',
        },
        texture: `sprite:/img/partials/puppets-master/puppets-1-${prefix}.json,1/`,
    },

    puppetsMaster2: {
        type: 'movieclip',
        scale: {
            x: '100%',
        },
        position: {
            x: '0%',
            y: '0%',
        },
        texture: `sprite:/img/partials/puppets-master/puppets-2-${prefix}.json,2/`,
    },

    puppetsMaster3: {
        type: 'movieclip',
        scale: {
            x: '100%',
        },
        position: {
            x: '0%',
            y: '0%',
        },
        texture: `sprite:/img/partials/puppets-master/puppets-3-${prefix}.json,3/`,
    },

    diplomePuppetsMaster: {
        texture: '/img/partials/puppets-master/diplome.png',
        scale: {
            x: '34%',
        },
        position: {
            x: '4%',
            y: '4%',
        },
    },

    stamp: {
        texture: '/img/partials/stamper/stamp.png',
        scale: {
            x: '40%',
        },
        position: {
            x: '6%',
            y: '30%',
        },
    },
};



// WEBPACK FOOTER //
// ./js/objects/partials/puppetMasters.js